<template>
    <body>
        <div class="top">
          <div class="topContent">
              <div class="topText1" @click="$router.push({path:'/courseShow',query:{'courseId':courseId}})">&lt; 返回</div>
              <div class="topText2">{{name}}</div>
              <div class="topText3" @click="$router.push({path:'/courseShow',query:{'courseId':courseId}})">回到课堂</div>
          </div>
        </div>
        <div class="homework">
          <div class="homeworkText1">作业</div>
          <!-- 大循环 -->
          <div :class="{'question':item.type==0||item.type==1,'question1':item.type==2,'question2':item.type==3}" v-for="(item, index) in qAList" :key="index">
            <img src="~@/assets/homework/答案正确.png" alt="" class="ansJudge" v-if="item.type!=2&&item.type!=3&&ansIsRight[index]==1">
            <img src="~@/assets/homework/答案错误.png" alt="" class="ansJudge" v-if="item.type!=2&&item.type!=3&&ansIsRight[index]==2">
            <img src="~@/assets/homework/讲师审阅.png" alt="" class="ansJudge-s" v-if="item.type!=0&&item.type!=1&&status==1">
            <div class="title">
              <div class="dian"></div>
              <div class="titleText" v-if="item.type==0">单选题 {{item.sort}}</div>
              <div class="titleText" v-if="item.type==1">判断题 {{item.sort-num}}</div>
              <div class="titleText" v-if="item.type==2">开放题</div>
              <div class="titleText" v-if="item.type==3">实践题</div>
            </div>
            <div class="quesContent">{{item.question}}</div>
            <img :src="item.pictureUrl" alt="" class="questionIcon" v-if="item.pictureUrl!=''&&item.pictureUrl!=null">
            <div class="select" v-for="(item1, index1) in item.opt" :key="index1">
              <img src="~@/assets/homework/选项_默认.png" alt="" class="selectImg1" @click="selectWhich(index,index1)">
              <img src="~@/assets/homework/选项_选中.png" alt="" class="selectImg1" v-if="selectAns[index][index1]&&homeworkResult==false&&status==0">
              <img src="~@/assets/homework/选项_选中置灰(作业回访).png" alt="" class="selectImg1" v-if="ansSelected[index][index1]&&status==1">
              <img src="~@/assets/homework/正确答案选项.png" alt="" class="selectImg2" v-if="ansRight[index][index1]">
              <div class="selectText">{{item1}}</div>
            </div>
            <!-- 开放题 -->
            <textarea
            v-model="openQues[index - numTwo]"  
            :id='"writeCommentId"+Number(index - numTwo)'
            class="writeComment"
            placeholder="请输入你的答案，不超过500字"
            @input="areaNumJudge"
            v-if="item.type==2" 
            ></textarea>
            <div class="selectText2" ><span v-if="item.type==2&&moreText[index - numTwo]==true">内容不能超过500字</span></div>
            <!-- 实践题 -->
            <div class="download" v-if="item.type==3" style="cursor: pointer;" @click="downloadFile(item.fileUrl)" @mouseover="fileDown=false" @mouseout="fileDown=true">
              <img src="~@/assets/homework/下载_默认.png" alt="" class="downloadImg" v-if="fileDown" >
              <img src="~@/assets/homework/下载_hover.png" alt="" class="downloadImg" v-if="!fileDown" >
              <div :class="fileDown == true ? 'selectText3' : 'selectText3-s'">下载样例数据.zip</div>
            </div>
            <!-- <img src="~@/assets/homework/样例数据缩略图.jpg" alt="" class="shijianImg" v-if="item.type==3"> -->
            <div class="download" v-if="item.type==3" style="cursor: pointer;margin-top: -110px;" @mouseover="hoverControl()" @mouseout="fileDown1=true">
              <img src="~@/assets/homework/上传_默认.png" alt="" class="downloadImg" v-if="fileDown1" >
              <img src="~@/assets/homework/上传_hover.png" alt="" class="downloadImg" v-if="!fileDown1" >
              <div :class="fileDown1 == true ? 'selectText3' : 'selectText3-s'" style="width: 500px;" id="selectText3Id">{{fileName}}</div> 
              <input
              type="file"
              class="fileUpload"
              name="file"
              id="file"
              @input="fileChange"
              />
            </div>
          </div>
          <!-- 提交作业按钮 -->
          <div class="inputHomework" @click="homeworkSubmit()" v-if="!homeworkResult">交作业</div>
          <div class="inputHomework-s" v-if="homeworkResult">已交作业</div>
        </div>
        <div class="shadow" v-if="shadow==1">
          <div class="tip">
              <div class="tipText1">提示</div>
              <div class="tipText2">请确认您上传的附件不超过1GB</div>
              <div class="tipText3" @click="shadow=0">确定</div>
          </div>
        </div>
        <div class="shadow" v-if="shadow==2">
          <div class="tip">
              <div class="tipText1" style="top: 40px;">提示</div>
              <div class="tipText2" style="top: 128px;width: 422px;left: calc(50% - 211px);text-align: left;">您有尚未完成的作业题目，请全部完成后再提交。</div>
              <div class="tipText2" style="top: 165px;width: 422px;left: calc(50% - 211px);text-align: left;font-size: 14px;color: #C49760;">注：您的作业完成情况将作为年度优秀学员评选的重要参考依据。</div>
              <div class="tipText3" @click="shadow=0">确定</div>
          </div>
        </div>
        <div class="shadow" v-if="shadow==3">
          <div class="tip">
              <div class="tipText1" style="top: 46px;width: 100px;">提交成功</div>
              <div class="tipText2" style="top: 128px;width: 422px;left: calc(50% - 211px);text-align: left;">您已完成{{name}}，欢迎您继续学习其他课程。
              </div>
              <div class="tipText2" style="top: 200px;width: 422px;left: calc(50% - 211px);text-align: left;font-size: 14px;color: #C49760;">注：您的作业完成情况将作为年度优秀学员评选的重要参考依据。</div>
              <div class="tipText3" @click="getHomework()">作业回访</div>
          </div>
        </div>
        <div class="shadow" v-if="shadow==4">
          <div class="tip">
              <div class="tipText4">恭喜！</div>
              <div class="tipText5">尊敬的学员，您已在规定时间内完成吉林一号遥感开发者培训班全部线上课程并提交作业，现可以申请《吉林一号·遥感开发者培训班结业证书》，希望您一如既往地继续关注吉林一号！
              </div>
              <div class="tipButton1" @click="$router.push('/graduationCertificate')">申请证书</div>
              <div class="tipButton1" style="left:408px;" @click="shadow=0">暂不需要</div>
          </div>
        </div>
        <div class="shadow" v-if="shadow==5">
          <div class="tip">
              <div class="tipText4">恭喜！</div>
              <div class="tipText5">尊敬的学员，您已完成吉林一号遥感开发者培训班全部线上课程并提交作业，希望您一如既往地继续关注吉林一号！
              </div>
              <div class="tipButton2" @click="shadow=0">关闭</div>
          </div>
        </div>
    </body>
</template>
<script>
export default {  
      name: "homeWork",
      data() {
        return {
          courseId:0,
          homeworkId:"",
          name:"",
          qAList:[],
          //单选题数量
          num:0,
          //单选和判断题数量
          numTwo:0,
          list:["A. NIR/R","B. (NIR-R)/G","C. (R-G)/(R+G)","D. (NIR-R)/(NIR+R)"],
          //用户选择
          selectAns:[[]],
          //正确答案
          ansRight:[[]],
          //正确错误左上角标志
          ansIsRight:[],
          //置灰选择
          ansSelected:[[]],
          openQues:[],
          moreText:[],
          fileDown:true,
          fileDown1:true,
          fileName:"上传我的结果",
          fileUp:[],
          shadow:0,
          homeworkResult:false,
          status:0,
          answer:[],
          xuanzeti:0,
          panduanti:0,
          kaifangti:0,
          shijianti:0
        };
      },
      methods: {
        getKey() {
          return localStorage.getItem("token");
        },
        hoverControl(){
          if(!this.homeworkResult){
            this.fileDown1=false
          }else{
            this.fileDown1=true
          }
        },
        getHomework(){
          this.homeworkId=this.$route.query.homeworkId;
          if(this.homeworkId!=undefined&&this.homeworkId!=''&&this.homeworkId!=null){
            localStorage.setItem('homeworkId',this.homeworkId)
          }
          if(this.homeworkId==undefined||this.homeworkId==''||this.homeworkId==null){
            this.homeworkId=localStorage.getItem('homeworkId')
          }else{
            this.homeworkId=this.$route.query.homeworkId;
          }
          this.axios.get(
            "/learn_back/course/homework/getHomeworkInfoById/"+this.homeworkId,
            {
              headers: {
                Authorization: "Bearer "+ this.getKey(),
              },
            }
          )
          .then((res) => {
            let resData = res.data;
            if (resData.code != 200) {
              alert("课程暂无作业");
            } else {
              this.qAList = resData.data.qAList
              this.xuanzeti=0
              this.panduanti=0
              this.kaifangti=0
              this.shijianti=0
              this.num=0
              for(let i=0;i<this.qAList.length;i++){
                if(this.qAList[i].type==0){
                  this.xuanzeti++
                }
                if(this.qAList[i].type==1){
                  this.panduanti++
                }
                if(this.qAList[i].type==2){
                  this.kaifangti++
                }
                if(this.qAList[i].type==3){
                  this.shijianti++
                }
              }
              this.answer=resData.data.answer
              this.name=resData.data.name
              this.numTwo=Number(this.xuanzeti+this.panduanti)
              let j =0
              resData.data.qAList.forEach((item) => {
                this.selectAns[j]=new Array()
                this.ansRight[j]=new Array()
                this.ansSelected[j]=new Array()
                
                for(let i=0;i<4;i++){
                  this.selectAns[j][i]=false
                  this.ansRight[j][i]=false
                  this.ansSelected[j][i]=false
                  
                }
                if(item.type==0){
                        this.num++
                    }
                j++
                })
                if(this.answer!=''&&this.answer!=null){
                this.status=1
                this.workSubmitted()
              }
            }
          });
        },
       
        selectWhich(index,index1){
          if(this.homeworkResult==false||status==false){
            this.selectAns[index]=[]
          this.selectAns[index][index1]=true
          // console.log(this.selectAns)
          this.$forceUpdate();
          }
          
        },
        downloadFile(url){
          window.location.href = url
        },
        areaNumJudge(){
          for(let i=0;i<this.openQues.length;i++){
            let a = this.openQues[i]
            if(a!=undefined&&a!=""&&a!=null){
            let contentDes2 = a.length;
            let writeCommentId = document.getElementById("writeCommentId"+i);
            if (contentDes2 < 1 || contentDes2 >500) {
              writeCommentId.style.border = "1px solid #FF4040";
              this.moreText[i]=true
            } else {
              writeCommentId.style.border = "1px solid rgba(0,0,0,0.2)";
              this.moreText[i]=false
            }
            } 
          }
               
        },
        fileChange(){
          let fileId = document.getElementById("file");
          let files = fileId.files;
          if ( files[0].size / 1024 / 1024 /1024 >1) {
          this.shadow=1
          this.fileUp=[]
          this.fileName="上传我的结果"
        }else{
          this.fileUp=files[0]
          this.fileName=this.fileUp.name
        }
        },
        homeworkSubmit(){
          //选择判断答案存储
          let ques1 = ''
          for(let i=0;i<this.numTwo;i++){
            let a =""
            for(let j=0;j<4;j++){
              if(this.selectAns[i][j]){
                a=j+1
              }
            }
            if(this.xuanzeti>0 || this.panduanti>0){
              if(a==""||a==null||a==0){
              this.shadow=2
              }else{
                // ques1.push(a)
                if(ques1==''){
                  ques1=a
                }else{
                  ques1=ques1+','+a
                }
                
              }
            }
          }
          //开放题
          if(this.kaifangti>0){
            for(let i=0;i<this.kaifangti;i++){
              if(this.openQues[i]==null || this.openQues[i]==undefined || this.moreText[i]==true){
                this.shadow=2
              }else{
                // ques1.push(this.openQues[i])
                if(ques1==''){
                  ques1=this.openQues[i]
                }else{
                  ques1=ques1+','+this.openQues[i]
                }
              }
            }
          }
          //实践题(先不改，默认只有一个实践题)
          let param = new FormData();
          if(this.shijianti>0){
            if(this.fileUp==null || this.fileUp=="" ||this.fileUp.length==0){
              this.shadow=2
            }else{
              // ques1.push(this.fileUp.name)
              param.append("filename", this.fileUp);
            }
          }
          if(this.shadow==0){
            param.append("homeworkId", this.homeworkId);
            param.append("answer", ques1);

            this.axios
              .post(
                "/learn_back/course/homework/submitUserHomework",param,
                {
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }
              )
              .then((res) => {  
                console.log(res);
                let resData = res.data;
                if (resData.code != 200) {
                  alert("提交作业失败");
                } else {
                  this.shadow=3
                }
              });    
          }
      },
      //作业状态已提交，直接显示判断
      workSubmitted(){
        this.shadow=0
        if(this.numTwo>0){
          for(let i=0;i<this.numTwo;i++){
          for(let j=1;j<5;j++){
            if(this.answer[i]==j){
              this.ansSelected[i][j-1]=true
            }
          }
        }
        }
        this.axios.get(
            "/learn_back/course/homework/getTrueAnswer/"+this.homeworkId,null,
            {
              headers: {
                Authorization: "Bearer "+ this.getKey(),
              },
            }
          )
          .then((res) => {
            let resData = res.data;
            if (resData.code != 200) {
              alert("作业暂未批改完成");
            } else  {
              this.homeworkResult=true
              if(this.numTwo>0){
                for(let i =0;i<resData.data.length;i++){
                  for(let j=0;j<4;j++){
                    if(resData.data[i]==j+1){
                      this.ansRight[i][j]=true
                      if(this.ansSelected[i][j]==true){
                        this.ansIsRight[i]=1
                      }else{
                        this.ansIsRight[i]=2
                      }
                    }
                  }
                }
              }
             if(this.kaifangti>0){
              for(let i=0;i<this.kaifangti;i++){
                let writeCommentId = document.getElementById("writeCommentId"+i) 
                writeCommentId.placeholder=this.answer[Number(this.numTwo + i)]
                writeCommentId.disabled="disabled"
                writeCommentId.style.color="#979797"
              }
             
              }
             if(this.shijianti>0){
              let selectText3Id = document.getElementById("selectText3Id")
              selectText3Id.style.color="#979797"
              this.fileName=this.answer[this.answer.length-1]
              let file = document.getElementById("file")
              file.style.zIndex="-100"
             }
             this.$forceUpdate();
             window.scrollTo({
              top: 0,
              left: 0,
              behavior: "instant",
            });
            }
          });
        if(this.$store.state.mode!=2){
          this.axios.post(
            "/learn_back/course/certificate/queryUserCertificateInfo",null,
            {
              headers: {
                Authorization: "Bearer "+ this.getKey(),
              },
            }
          ) .then((res) =>{
            let resData = res.data;
           if (resData.success){
              if(resData.data.visitStatus==1){
                if(resData.data.applyStatus==1){
                this.shadow=4
                }else if(resData.data.applyStatus==2){
                  this.shadow=5
                }
              }
              
            }
          })
        }
        
          
      }
        },
      mounted() {
        this.courseId=this.$route.query.courseId;
        // console.log(this.courseId)
        this.getHomework()
        // console.log(this.shadow)

      },
      watch:{
        
      },
      computed: {
        
      },
    };
</script>
<style scoped>
    .top{
      position: relative;
      width: 100%;
      height: 76px;
    background: #FFFFFF;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    }
    .topContent{
      position: absolute;
      width: 1280px;
      height: 76px;
      left: calc(50% - 640px);
    }
    .topText1{
      position: absolute;
      left: 0;
      width:80px;
height: 76px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 500;
color: #3A3A3A;
line-height: 76px;
cursor: pointer;
    }
    .topText2{
      position: absolute;
      width: 500px;
      left: calc(50% - 250px);
      height: 76px;
      font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height:76px;
text-align: center;
    }
    .topText3{
      position: absolute;
      top: 18px;
      right: 0;
      width: 112px;
height: 40px;
background: #C49760;
border-radius: 20px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height:40px;
text-align: center;
cursor: pointer;
    }
    .homework{
      /* margin-top: 16px; */
      width: 100%;
      height:auto;
    }
    .homeworkText1{
      margin-top: 54px;
      margin-bottom: 53px;
      margin-left: calc(50% - 50px);
      width: 100px;
height: 42px;
font-size: 30px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 42px;
text-align: center;
    }
    .question{
      margin-left: calc(50% - 640px);
      margin-bottom: 20px;
      padding-bottom:34px;
      width: 1280px;
height: auto;
background: linear-gradient(135deg, #F7F7F7 0%, #FCFCFC 100%);
border-radius: 16px;
overflow: hidden;
    }
    .question1{
      margin-left: calc(50% - 640px);
      margin-bottom: 20px;
      padding-bottom: 34px;
      width: 1280px;
height: auto;
background-image:url(~@/assets/homework/开放题背景.png);
border-radius: 16px;
overflow: hidden;
    }
    .question2{
      margin-left: calc(50% - 640px);
      margin-bottom: 20px;
      padding-bottom: 34px;
      width: 1280px;
height: auto;
background-image:url(~@/assets/homework/实践题背景.png);

border-radius: 16px;
overflow: hidden;
    }
    .ansJudge{
      float: left;
      width: 75px;
      height: 75px;
      margin-top: 0;
      margin-left: 0;
    }
    .ansJudge-s{
      float: left;
      width: 138px;
      height: 51px;
      margin-top: 0px;
      margin-left: 0px;
    }
    .title{
      position: relative;
      width: auto;
      height: 26px;
      margin-top: 30px;
      margin-left: 50%;
      transform: translate(-6%, 0);
    }
    .dian{
      position: absolute;
      top: 7px;
      width: 9px;
      height: 9px;
      background: #5A5A5A;
      border-radius: 50%;
    }
    .titleText{
      position: absolute;
      left: 19px;
      width: auto;
height: 26px;
font-size: 20px;
font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #5A5A5A;
line-height: 26px;
    }
    .quesContent{
      margin-top: 35px;
      margin-left: 69px;
      margin-bottom: 45px;
      width: 1142px;
      height: auto;
      font-size: 18px;
font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #5A5A5A;
line-height: 26px;
    }
    .questionIcon{
      margin-top: -15px;
      margin-bottom: 25px;
      margin-left: 50%;
      transform: translate(-50%, 0);
    }
    .select{
      position: relative;
margin-bottom: 25px;
margin-left: 69px;
width: 1142px;
      height: auto;
      font-size: 18px;
font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #5A5A5A;
line-height: 26px;
    }
    .selectImg1{
      position: absolute;
      top: 2px;
      left: 0;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
    .selectImg2{
      position: absolute;
      top: -6px;
      left: -8px;
      width: 36px;
      height: 36px;
      cursor: pointer;
    }
    .selectText{
      margin-left: 30px;
      width: auto;
    font-size: 18px;
    font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
    font-weight: normal;
    color: #5A5A5A;
    line-height: 26px;
    }
    .writeComment{
      margin-left: 69px;
      width: 1142px;
height: 239px;
background:transparent;
border-radius: 8px;
border: 1px solid rgba(0,0,0,0.2);
  outline: none;
  padding-top: 16px;
  padding-left: 22px;
  padding-right: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight:500;
  color: #000000;
  line-height: 20px;
  resize: none;
    }
    .selectText2{
      margin-top: 10px;
    margin-left:69px;
    width: 106px;
height: 24px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FF4040;
line-height: 24px;
    }
    .download{
      position: relative;
      float: left;
      margin-top: 30px;
      margin-left: 71px;
      width: 160px;
      height: 20px;
      /* background-color: pink; */
    }
    .downloadImg{
      position: absolute;
      width: 20px;
      height: 20px;
      top: 0;
      left: 0;
    }
    .fileUpload{
      position: absolute;
      top: 0;left:0;
      width: 136px;
     height:20px;
     background-color: pink;
     opacity: 0;
  cursor: pointer;
  box-sizing: border-box;
  padding: 20px;
  z-index: 1;
    }
    .fileNow{
      position: absolute;
      top: 0;
      left: 150px;
      width: 500px;
      height: 20px;
      font-size: 17px;
font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #5A5A5A;
line-height: 20px;
/* background-color: pink; */
    }
    .selectText3{
      position: absolute;
      top: 0;left: 26px;
      width: 136px;
     height: 20px;
font-size: 18px;
font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #5A5A5A;
line-height: 20px;
    }
    .selectText3-s{
      position: absolute;
      top: 0;left: 26px;
      width: 136px;
     height: 20px;
font-size: 18px;
font-family: Tensentype-ZhiHeiJ-W2, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #C49760;
line-height: 20px;
    }
    .shijianImg{
      float: left;
      margin-top: -20px;
      width: 380px;
      height: 280px;
      margin-left: 576px;
      margin-bottom: 20px;
    }
    .inputHomework{
      margin-top: 101px;
      margin-bottom: 100px;
      margin-left: calc(50% - 75px);
      width: 150px;
height: 54px;
background: rgba(255,255,255,0.25);
border-radius: 27px;
border: 1px solid #C49760;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight:500;
color: #C49760;
line-height: 54px;
text-align: center;
cursor: pointer;
    }
    .inputHomework:hover{
      background: #C49760;
border-radius: 27px;
border: 1px solid #C49760;

color: #FFFFFF;
    }
    .inputHomework-s{
      margin-top: 101px;
      margin-bottom: 100px;
      margin-left: calc(50% - 75px);
      width: 150px;
height: 54px;
background: rgba(255,255,255,0.25);
border-radius: 27px;
border: 1px solid #CCCCCC;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight:500;
color: #CCCCCC;
line-height: 54px;
text-align: center;
    }
    .shadow{
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;left: 0;
background: rgba(0,0,0,0.5);
z-index: 10000;
    }
    .tip{
      position: absolute;
      top: calc(50% - 200px);
      left: calc(50% - 400px);
      width: 800px;
height: 400px;
background: #FFFFFF;
border-radius: 16px;
    }
    .tipText1{
      position: absolute;
      top: 46px;
      left: calc(50% - 50px);
      width:100px;
height: 28px;
font-size: 20px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 28px;
text-align: center;
    }
    .tipText2{
      position: absolute;
      top: 143px;
      left: calc(50% - 250px);
      width: 500px;
height: 36px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 36px;
text-align: center;
    }
    .tipText3{
      position: absolute;
      top: 290px;
      left: calc(50% - 56px);
      width: 112px;
height: 44px;
background: #C49760;
border-radius: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 44px;
text-align: center;
cursor: pointer;
    }
    .tipText4{
      position: absolute;
      top: 46px;
      left: calc(50% - 50px);
      width: 100px;
height: 28px;
font-size: 20px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 28px;
text-align: center;
    }
    .tipText5{
      position: absolute;
      top: 127px;
      left: calc(50% - 250px);
      width: 500px;
height: 110px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 500;
color: #000000;
line-height: 36px;
text-align: center;
    }
    .tipButton1{
      position: absolute;
      top: 290px;
      left: 281px;
      width: 112px;
height: 44px;
border-radius: 22px;
border: 1px solid #C49760;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #C49760;
line-height: 44px;
text-align: center;
cursor: pointer;
    }
    .tipButton1:hover{
      background-color:#C49760 ;
      color: #ffffff;
    }
    .tipButton2{
      position: absolute;
      top: 290px;
      left: calc(50% - 66px);
      width: 112px;
height: 44px;
background: #C49760;
border-radius: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #FFFFFF;
line-height: 44px;
text-align: center;
cursor: pointer;
    }
</style>